import '../styles/legal.css';

/**
 * LegalFooter — the Privacy / Terms link row (card cEchedAassmt).
 *
 * One component, three placements:
 *  - variant="page"   bottom of the signed-out page (landing + pair) — the
 *                     public landing footer;
 *  - variant="menu"   foot of the More menu — the links stay reachable from
 *                     every screen of the signed-in app;
 *  - variant="legal"  foot of the /privacy and /terms screens themselves.
 *
 * Real <a href> links, not SPA pushes: the app has no client router and a
 * policy page is meant to be a loadable, shareable URL.
 */

interface Props {
  variant?: 'page' | 'menu' | 'legal';
}

export function LegalFooter({ variant = 'page' }: Props) {
  return (
    <footer className={`pear-legal-footer pear-legal-footer-${variant}`} data-testid="legal-footer">
      <a className="legal-footer-link" id={`legal-footer-privacy-${variant}`} href="/privacy">
        Privacy
      </a>
      <span className="legal-footer-sep" aria-hidden="true">
        ·
      </span>
      <a className="legal-footer-link" id={`legal-footer-terms-${variant}`} href="/terms">
        Terms
      </a>
    </footer>
  );
}
